export { useOtp } from './hook';
export type {
  Hook,
  OnNextOtpResendableTimeChange,
  OnOtpAttemptsReached,
  OnOtpCodeChange,
  OnOtpCodeComplete,
  OnOtpCodeExpiredTimeChange,
  OnOtpRetryAttemptsChange,
  OnOtpVerify,
  OnUnknownErrorThrow,
  OtpCode,
  Props,
  Result,
} from './types';
